export default __webpack_public_path__ + "static/media/rambouillet28.fcb969b6.jpg";